import styled from 'styled-components'

import mediaQueries from 'components/media-queries'
import {oops as e2eClasses} from 'constants/e2eClasses'

export const ErrorWrapper = styled.div`
  display: none;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  margin: 10px 0;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.colors.valenciaRed};
  background-color: ${({ theme }) => theme.colors.redLight};
`

export const ErrorTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const ErrorTitle = styled.div.attrs(() => ({
  className: e2eClasses.title
}))`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.red};
  font-size: 20px;
  text-align: center;
  margin-top: 0;

  ${mediaQueries.mobile`
    font-size: 22px;
  `};
`

export const ErrorButtonWrapper = styled.div`
  grid-gap: 15px;
  margin: 15px 0;
`

export const ErrorMessage = styled.div`
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.red};
  text-align: center;
  font-size: 16px;
  margin-top: 5px;
`
